import { useOt } from "../../../../shared/context/otContext"
import { useEffect } from "react"
import { Box, Typography, Avatar } from "@mui/material"
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { useUtiles } from "../../../../shared/context/utilesContext"
import moment from "moment"
import { useTheme } from "@mui/material/styles"

export const HistoryOt = () => {
    const theme = useTheme()

    const { otHistory, loadingOtHistory, ot, getOtHistory } = useOt()

    const { getFirstNameAndLastName, statusOptions } = useUtiles()

    useEffect(() => {
        getOtHistory(ot.hash_code)
    }, [])

    // Ordenar el historial para que la creación aparezca al final
    const sortedHistory = [...otHistory].sort((a, b) => {
        // Si es el registro de creación, ponerlo al final
        if (a.type_history === 'history') return 1;
        if (b.type_history === 'history') return -1;
        // Para los demás registros, mantener el orden cronológico inverso
        return new Date(b.created_at) - new Date(a.created_at);
    });

    if (loadingOtHistory) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Typography>Cargando historial de la OT...</Typography>
        </Box>
    }

    return (
        <Box sx={{ p: 2 }}>
            <Timeline sx={{
                [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                },
            }}>
                {sortedHistory.map((item) => (
                    <TimelineItem key={item.id}>
                        <TimelineSeparator>
                            <TimelineDot 
                                sx={{ height: 15, width: 15 }} 
                                color={item.type_history === 'status' ? statusOptions.find(status => status.value === item.name)?.color : 'success'} 
                            />
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent sx={{ p: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography component="span" sx={{ fontSize: '14px', fontWeight: 'bold' }}>
                                    {item.type_history === 'status' ? statusOptions.find(status => status.value === item.name)?.label : item.name}
                                </Typography>
                                {item.created_at && (
                                    <Typography component="span" sx={{ fontSize: '12px', color: 'gray' }}>
                                        ({moment(item.created_at).format('DD/MM/YYYY hh:mm A')})
                                    </Typography>
                                )}
                            </Box>
                            <Typography sx={{ fontSize: '12px' }}>
                                {item.type_history === 'status' 
                                    ? "Se ha cambiado el estado de la OT a " + statusOptions.find(status => status.value === item.name)?.label 
                                    : item.description}
                            </Typography>
                            
                            {item.comment && (
                                <Typography component="div" sx={{ fontSize: '12px', borderRadius: 1, p: 1, backgroundColor: theme.palette.background.medium, color: theme.palette.text.primary, mt: 0.5 }}>
                                    {item.comment}
                                </Typography>
                            )}

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography component="span" sx={{ fontSize: '12px', color: 'gray', mt: 1 }}>
                                    Modificado por:
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pt: 1 }}>
                                    <Avatar src={item.user.avatar || item.user.name} sx={{ width: 20, height: 20 }} />
                                    <Typography component="span" sx={{ fontSize: '12px', textTransform: 'capitalize' }}>
                                        {getFirstNameAndLastName(item.user.fullName).toLowerCase()}
                                    </Typography>
                                </Box>
                            </Box>
                        </TimelineContent>
                    </TimelineItem>
                ))}
            </Timeline>
        </Box>
    )
}